export default __webpack_public_path__ + "static/media/seleccionados_cdmx.264a12c7.pdf";